<template>
  <div>
    <div v-observe-visibility="checkMainSectionScroll" class="nav-bar-toggler" />
    <div class="main-scn-emitter" />
    <section class="main-scn" @click="scrollToTextContent">
      <logo-anim-phrase />
      <span class="main-scn__chevron">
        <font-awesome-icon icon="chevron-down" />
      </span>
      <contact-qr v-if="!$store.state.isMobile" />
    </section>
    <div class="text-content">
      <scn data-name="unique" class="relative overflow-hidden">
        <img :src="$getImage('onesti-logo/a-pattern.svg')" class="a-pattern" aria-hidden="true" alt="null">
        <div class="website-presentation container">
          <h2 class="website-presentation__title">
            {{ $t('presentation.title') }}
          </h2>
          <p class="website-presentation__text">
            {{ $t('presentation.text') }}
          </p>
        </div>
        <section-header :title="$t('unique.title')"
                        :subtitle="$t('unique.subtitle')"
                        alignment="center"
        />
        <div class="scn__content container">
          <div class="column-text-ctn">
            <p v-for="paragraph in $t('unique.paragraphs')" class="mb-2">
              {{ paragraph }}
            </p>
          </div>
        </div>
      </scn>
      <scn data-name="from" color="grey">
        <section-header
          :title="$t('from.title')"
          :subtitle="$t('from.subtitle')"
          alignment="center"
        />
        <div class="scn__content container">
          <div class="column-text-ctn">
            <p v-for="paragraph in $t('from.paragraphs')" class="mb-2">
              {{ paragraph }}
            </p>
          </div>
        </div>
      </scn>
      <lazy-loaded-content v-if="isComponentMounted" />
    </div>
    <script type="application/ld+json">
      {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Onesti Advogados",
      "url": "https://www.onestiadvogados.com.br",
      "image": "https://www.onestiadvogados.com.br/img/onesti-logo-pt.svg",
      "telephone": "+55 (11) 3262-4647",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "BR",
        "addressRegion": "São Paulo",
        "postalCode": "01310916",
        "streetAddress": "Avenida Paulista, nº 91, 1º andar, 101, Bela Vista"
      }}
    </script>
  </div>
</template>

<script>
import LogoAnimPhrase from '@/views/logo-anim-phrase'
import SectionHeader from '@/components/section-header'
import { TweenLite } from 'gsap'
import ContactQr from '@/components/contact-qr'
const LazyLoadedContent = () => import('@/components/lazy-loaded-content')

require('../../node_modules/gsap/ScrollToPlugin')
export default {
  name: 'Home',
  components: { ContactQr, SectionHeader, LogoAnimPhrase, LazyLoadedContent },
  data () {
    return {
      isComponentMounted: false
    }
  },
  methods: {
    scrollToTextContent () {
      TweenLite.to(window, 1, { scrollTo: '.text-content', autoKill: false })
    },
    checkMainSectionScroll (isMainSectionVisible, { target }) {
      if (isMainSectionVisible) {
        const sectionName = target.parentNode.getAttribute('data-name')
        this.$root.$emit('current-section-change', sectionName)
        this.$root.$emit('nav-bar-transparent')
      } else this.$root.$emit('nav-bar-black')
    }
  },
  created () {
    sessionStorage.setItem('didEnterFullHome', 'true')
  },
  mounted () {
    this.isComponentMounted = true
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.main-scn
  @apply flex items-center justify-center cursor-pointer w-full h-screen
  background-color: rgba(186, 52, 105, 0.6)
  background-size: cover
  background-image: url('~@/assets/images/vista-rua-com-predios@small.jpg')
  @screen md
    background-image: url('~@/assets/images/vista-rua-com-predios@medium.jpg')
  @screen xl
    background-image: url('~@/assets/images/vista-rua-com-predios@large.jpg')
  &__chevron
    @apply absolute half-l -translate-x-50 text-4xl text-white
    top: calc(100% - 60px)
    animation: chevron 2s infinite alternate-reverse

.text-content
  @apply bg-white

.a-pattern
  @apply hidden absolute w-48
  right: -40px
  top: -50px
  @screen xl
    @apply block

.website-presentation
  @apply text-center mb-5 mx-auto
  &__title
    @apply text-3xl text-grey-darker uppercase mb-2 mx-auto
    @screen md
      @apply text-5xl
    @screen lg
      width: 51rem
  &__text
    @apply leading-normal mx-auto
    max-width: 750px

.column-text-ctn
  columns: 1
  @screen md
    columns: 2
    column-gap: 2.5rem
    p
      @apply inline-flex
      page-break-inside: avoid

.nav-bar-toggler
  @apply absolute z-50 pin-t pin-l w-full h-full pointer-events-none

.main-scn-emitter
  @apply absolute z-50 pin-l bg-yellow w-px h-px
  top: 100vh

@keyframes chevron
  from
    transform: translate(-50%, -10px)
  to
    transform: translate(-50%, 10px)
</style>
